import { ReactElement } from 'react'
import { TextField } from '@ui/forms'
import { Box } from '@ui/structure'

const OrganisationFormFields = (): ReactElement => (
  <Box display="flex" flexDirection="column" gap={2} pt={1}>
    <TextField name="name" label="Name" data-cy="input-organisation-name" />
    <TextField name="street" label="Straße" data-cy="input-organisation-street" />
    <Box display="flex" gap={2}>
      <TextField name="zipCode" label="PLZ" data-cy="input-organisation-zip-code" />
      <TextField name="city" label="Stadt" data-cy="input-organisation-city" />
    </Box>
  </Box>
)

export default OrganisationFormFields
